const navMenu = {
    navbar: null,

    init() {
        let self = this;
        self.navbar = document.querySelector('.c-navbar');

        if(self.navbar) {
            self._menuButtonsBehaviour();
        }
    },

    _menuButtonsBehaviour() {
        let self = this;

        let menuButton = document.querySelector('.js-navbar-btn');
        self.menuBtnRef = self._toggleMenu.bind(null, self, menuButton);
        menuButton.addEventListener('click', self.menuBtnRef, null);
        self.menuItemsArray = [];

        let menuItems = self.navbar.querySelectorAll('.c-navbar__item-btn');

        menuItems.forEach((menuItem, index) => {
            self.menuItemsArray[index] = menuItem.addEventListener('click', self._toggleMenuItem, null);
        });
    },

    _toggleMenu(self, menuButton) {
        self.navbar.classList.toggle('block');
        menuButton.classList.toggle('open');
        
    },

    _toggleMenuItem() {
        let dropDown = this.closest('.c-navbar__item').querySelector('.c-navbar__dropdown');
        this.classList.toggle('rotate');
        dropDown.classList.toggle('block');
    },

   /* _createEvents(navbar) {
        let self = this;

        let openMenuBtn = navbar.querySelector('.js-open-navbar-btn');
        let closeMenuBtn = navbar.querySelector('.js-close-navbar-btn');
        
        
        self.openMenuBtnRef = self._openMenu.bind(null, self, navbar);
        openMenuBtn.addEventListener('click', self.openMenuBtnRef, null);

        self.closeMenuBtnRef = self._closeMenu.bind(null, self, navbar);
        closeMenuBtn.addEventListener('click', self.closeMenuBtnRef, null);
    },

    _openMenu(self, navbar) {
        let menu = navbar.querySelector('.js-navbar-content');

        menu.classList.add('block');
        menu.classList.remove('hidden');
    },
    */


    _closeMenu() {
        let navbar = document.querySelector('.c-navbar');
        let menuButton = document.querySelector('.js-navbar-btn');

        navbar.classList.remove('block');
        menuButton.classList.remove('open');
    }

};

window.navMenu = navMenu;

window.navMenu.init();

document.addEventListener('LokiRequestEnd', function () {
    window.navMenu.init();
});